import React, { useMemo, useRef } from "react";
import classes from "./DoctorsList.module.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
// import DoctorCard from "./doctor-card/DoctorCard";
import useDeviceWidth from "../../../components/device-width/UseDeviceWidth";
import DoctorCard from "../../../components/page-components/doctor-card/DoctorCard";
import { useLocation } from "react-router-dom";

const DoctorsList = ({ data, branchHisId = null }) => {
  const swiperRef = useRef(null);
  const width = useDeviceWidth();
  const location = useLocation();

  const slidesPerView = useMemo(() => {
    return width > 1800
      ? 7
      : width > 1200
        ? 5
        : width > 1100
          ? 4
          : width > 720
            ? 3
            : width > 600
              ? 2
              : 1;
  }, [width]);

  const items = data?.listingItems ?? [];
  const shouldCarousel = items.length > slidesPerView;

  return (
    <div className={classes.outer}>
      <img
        src="/img/doctor-pattern.svg"
        className={classes.pattern}
        alt="pattern"
      />
      <div className={classes.innerContent}>
        <div
          className={classes.title}
          data-aos="fade-down"
          data-aos-delay="150"
        >
          <h1 className="bg-primary-200">{data?.subTitle}</h1>
          {data?.showTitle && (
            <h5 dangerouslySetInnerHTML={{ __html: data?.title }}></h5>
          )}
        </div>

        <div className={classes.sliderOuter}>
          <div className={classes.arrowDiv}>
            <img
              src="/img/title-symbol.svg"
              className={classes.titleSymbol}
              alt="symbol"
            />
            {shouldCarousel && (
              <div className={classes.arrows}>
                <img
                  className={classes.leftArrow}
                  src="/img/doctor-left.svg"
                  alt="Prev"
                  onClick={() => swiperRef.current?.slidePrev()}
                />
                <img
                  src="/img/doctor-right.svg"
                  className={classes.rightArrow}
                  alt="Next"
                  onClick={() => swiperRef.current?.slideNext()}
                />
              </div>
            )}
          </div>

          <div className="outer-outer">
            {shouldCarousel ? (
              <div
                onMouseEnter={() => swiperRef.current?.autoplay?.stop()}
                onMouseLeave={() => swiperRef.current?.autoplay?.start()}
              >
                {/* Swiper */}
                <Swiper
                  slidesPerView={slidesPerView}
                  spaceBetween={20}
                  onSwiper={(swiper) => (swiperRef.current = swiper)}
                  pagination={{ clickable: true }}
                  loop={true}
                  draggable={true}
                  modules={[Autoplay]}
                  autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                  }}
                >
                  {items.map((slide) => (
                    <SwiperSlide key={slide.id}>
                      <DoctorCard
                        data={slide}
                        className={classes.cardHeight}
                        checkIsDisable={true}
                        branchHisId={branchHisId}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            ) : (
              // Not enough items: show as normal cards with same design, no arrows
              <div className={classes.cardsGrid}>
                {items.map((slide) => (
                  <div key={slide.id} className={classes.cardGridItem}>
                    <DoctorCard
                      data={slide}
                      className={classes.cardHeight}
                      checkIsDisable={true}
                      branchHisId={branchHisId}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoctorsList;
